// ── 스트리밍 텍스트 부드러운 표시기 ────────
// 토큰을 받을 때마다 즉시 다시 그리면(네트워크 버스트) 글자가 뚝뚝 끊겨 보인다.
// 받은 본문은 ref에 모으고, requestAnimationFrame으로 프레임당 일정 속도로 '타이핑'하듯 노출해
// 표시 cadence를 화면 주사율(~60fps)에 맞춘다. apply(content)는 마지막 assistant 메시지 본문을 갱신.
export function createSmoothStreamer(apply) {
  let target = '';   // 지금까지 수신한 본문
  let suffix = '';   // 완료 시 한 번에 붙일 마커(문서 카드 등) — 부분 노출 방지
  let shown = 0;
  let done = false;
  let raf = 0;
  let running = false;
  let killed = false;  // flushNow 이후 stale 콜백/늦은 토큰이 새 메시지에 쓰는 것 방지

  const tick = () => {
    if (killed) { running = false; return; }
    if (shown < target.length) {
      const remaining = target.length - shown;
      // ease-out: 남은 양에 비례(최소 2자/프레임). 큰 버스트도 몇 프레임 내 따라잡음.
      const step = Math.max(2, Math.ceil(remaining / 5));
      shown = Math.min(target.length, shown + step);
      apply(target.slice(0, shown));
    }
    if (done && shown >= target.length) {
      running = false;
      if (suffix) apply(target + suffix);
      return;
    }
    raf = requestAnimationFrame(tick);
  };
  const ensure = () => { if (killed || running) return; running = true; raf = requestAnimationFrame(tick); };

  return {
    push(text) { if (killed) return; target += text; ensure(); },
    addSuffix(text) { if (killed) return; suffix += text; },
    finish() { if (killed) return; done = true; ensure(); },   // 수신 완료: 남은 글자 다 노출 후 종료
    flushNow() {                                   // 중지/오류/새 요청: 즉시 전량 표시하고 영구 정지
      if (raf) cancelAnimationFrame(raf);
      done = true; shown = target.length; running = false;
      if (!killed) apply(target + suffix);
      killed = true;
    },
  };
}
